import React from 'react'

import Reviews from './Reviews';

import img_me from '../images/Polymedia-Peter_van_der_Meer.jpg';
import fitness_video from '../videos/INFLOW-fitness.mp4';


export default class extends React.Component {

  render() {
    document.title = "Peter van der Meer | INFLOW Online Marketing Bureau | Helpt jouw bedrijf groeien.";

    return (
      <div>

        <div className="full" style={{paddingTop:"2em", paddingBottom:"2em"}}>

          <div className="wrap">
            <div className="col-2" style={{padding:"3%"}}>
              <h2 className="logo-text" style={{fontSize:"1.2em", marginBottom:".3em"}}><span style={{opacity:".7"}}>voor</span> boutique fitness studio's</h2>
              <h1 style={{fontSize:"3.1em", fontFamily:"Times New Roman, Times, serif", marginTop:"0", marginBottom:".3em"}}>Gym eigenaren:<br/>Halfvolle lessen.<br/>Elke week opnieuw.<br/><br/>Dat is je probleem.</h1>
              <h2 style={{fontSize:"1.1em", opacity:".7", margin:"1em 0 2.3em"}}>Niet je aanbod. Niet je locatie.<br/>Jouw instroom.<br/><br/>Niet voor sporters.<br/>Alleen voor studio’s met 50–150 leden.<br/><br/>We testen 5 advertenties in 7 dagen en houden alleen wat daadwerkelijk proefleden oplevert.</h2>
              <div><a href="https://www.facebook.com/inflow.marketing/" target="blank" className="btn btn-fat btn-if btn-if-fill-red">Ontvang 5 advertentie-invalshoeken</a><a style={{display:"inline-block",marginTop:"2em"}} href="https://www.facebook.com/inflow.marketing/" target="blank"><img src={img_me} alt="INFLOW Online Marketing | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #fff", width:"90px"}} /></a></div>
            </div>
            <div className="col-2" style={{textAlign:"center"}}>
              <div style={{position:"relative"}}>
                <video width="530" height="298" controls className="mt8-responsive" style={{maxWidth:"100%"}}>
                  <source src={fitness_video} type="video/mp4"/>
                </video>
              </div>
            </div>
          </div>

        </div>

        <div className="full greyish">
          <div className="wrap content-block">
            <div className="col-2 usp">
              <h3>Herken je dit?</h3>
              <ul style={{listStyleType:"square", paddingLeft:"1.1em"}}>
                <li>Je lessen zitten niet vol</li>
                <li>Je weet nooit hoeveel nieuwe leden er komen</li>
                <li>Soms zit je vol.. soms valt het stil</li>
                <li>Je hebt al ads geprobeerd, maar het werkte niet</li>
              </ul>
            </div>
            <div className="col-2 usp">
              <h3>Wat ik doe</h3>
              <p>Ik regel geen marketing.<br/><br/>Ik regel jouw instroom.<br/><br/>Geen strategie.<br/>Geen content shoots.<br/>Geen traject van maanden.<br/><br/>We testen 5 advertenties in 7 dagen.<br/><br/><b>Wat werkt: schalen we.</b><br/><b>Wat niet werkt: stoppen we.</b></p>
            </div>
          </div>
        </div>

        <div className="full">
          <div className="wrap content-block">
            <h2>Aanbod</h2>
            <div className="col-3-center">
              <p style={{marginBottom:"2em"}}>Geen traject van €40.000.<br/>Geen €3.000 per maand.<br/>Geen bullshit.<br/><br/>Gewoon: testen wat werkt.</p>
              <ul style={{listStyleType:"square", paddingLeft:"1.1em"}}>
                <li>Ik zet campagnes op</li>
                <li>We testen meerdere invalshoeken</li>
                <li>Doel: binnen 7 dagen proefleden binnenhalen</li>
                <li>Eenmalig traject van slechts 7 dagen</li>
              </ul>
              <p style={{marginTop:"1em", fontSize:"85%"}}><b>Eenmalig</b> <span style={{color:"#8bc34a"}}>450</span></p>
              <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontSize:"85%"}}>
                <li>Incl. startkosten t.w.v. <span style={{color:"#8bc34a"}}>150</span></li>
                <li>Incl. advertentiebudget t.w.v. <span style={{color:"#8bc34a"}}>300</span></li>
              </ul>
              <small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%"}}>Startkosten zijn exclusief 21% BTW, advertentiebudget wordt betaald aan Meta.</small>
              <h3 style={{margin:"1em 0 0"}}>Maximaal 10-12 gyms per maand.</h3>
              <p>Omdat ik per sportschool maatwerk doe en resultaten wil leveren.</p>
            </div>
          </div>
        </div>

        <div className="full greyish">
          <div className="wrap content-block">
            <div className="col-3-center">
              <p style={{marginBottom:"2em"}}>Elke week dat je dit niet oplost:<br/><br/>– blijven jouw lessen halfvol<br/>– blijft jouw instroom onvoorspelbaar<br/>– en blijf je afhankelijk van geluk<br/><br/>Dat verandert niet vanzelf.</p>
            </div>
          </div>
        </div>

        <div className="full big accent" style={{background:"#116CB2"}}>
          <div className="wrap content-text">
            <h2 className="cta-title" style={{color:"#F2AA22"}}>Zie waar jouw instroom op vastloopt</h2>
            <p style={{textAlign:"center", opacity:"0.8"}}>15 minuten.<br/>Geen sales pitch.<br/>Gewoon kijken of het past.</p>
            <div style={{textAlign:"center", marginTop:"3em"}}><a href="https://zcal.co/peterghostin/inflow-15min" target="blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-red">Direct naar zcal</a></div>
          </div>
        </div>

        <div className="full greyish">
          <div className="wrap content-block">
            <h2>Veelgestelde vragen</h2>
            <div style={{width:"30%", margin:"0 auto"}}>
              <h3 style={{margin:"1em 0 0"}}>"Werkt dit voor elke sportschool?"</h3>
              <p>Nee. We kijken eerst of het past.</p>
              <h3 style={{margin:"1em 0 0"}}>"Moet ik al advertenties actief hebben?"</h3>
              <p>Nee.</p>
              <h3 style={{margin:"1em 0 0"}}>"Zit ik ergens aan vast?"</h3>
              <p>Nee, we starten met een test.</p>
            </div>
          </div>
        </div>

        <Reviews limited />

        <div className="full big greyish">
          <div className="wrap content-block">
            <div style={{textAlign:"center"}}>
              <h1 style={{margin:"1rem 0 2rem", textAlign:"center"}}>Geen koffie en vlotte babbels.</h1>
              <p style={{fontSize:"20px", textAlign:"center", marginTop:"0", marginBottom:"5em"}}>
              Mijn naam is Peter van der Meer, en ik ben woonachtig in Leerdam (Utrecht). Na jarenlange ervaring met allerlei ondernemingen heb ik genoeg ervaring opgebouwd met marketing dat ik op het idee kwam om mijn eigen Online Marketing Bureau te beginnen. Mijn doel is om voor jou meer omzet te genereren.
              <br/><br/>
              Dit bedrijf werkt volledig remote, ik heb dus ook geen kantoor. Contact gaat in eerste instantie via E-mail en videobellen, en ook tijdens onze samenwerking heeft dit mijn voorkeur. Tijdens onze samenwerking kunnen we ook andere manieren van contact afspreken.
              <br/><br/>
              Benieuwd of ik jouw bedrijf kan helpen? Neem geheel vrijblijvend contact met mij op door een bericht te sturen via LinkedIn.
              </p>
              <div style={{marginBottom:"5em"}}><a href="/contact" className="btn btn-fat btn-if btn-if-fill-blue">Neem contact op</a><a href="/contact"><img src={img_me} alt="INFLOW Online Marketing | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #116CB2", width:"90px"}} /></a></div>
            </div>
          </div>
        </div>

        <div className="full big accent" style={{background:"#116CB2"}}>
          <div className="wrap content-text">
            <h2 className="cta-title" style={{color:"#F2AA22"}}>Zie waar jouw instroom op vastloopt</h2>
            <p style={{textAlign:"center", opacity:"0.8"}}>15 minuten.<br/>Geen sales pitch.<br/>Gewoon kijken of het past.</p>
            <div style={{textAlign:"center", marginTop:"3em"}}><a href="https://zcal.co/peterghostin/inflow-15min" target="blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-red">Direct naar zcal</a></div>
          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Fitness.js